import { render, staticRenderFns } from "./collection-records.vue?vue&type=template&id=08afe1ec&scoped=true&"
import script from "./collection-records.vue?vue&type=script&lang=js&"
export * from "./collection-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08afe1ec",
  null
  
)

export default component.exports